import {faCheck} from "@fortawesome/free-solid-svg-icons";

export default faCheck;
